import * as React from 'react';
var RadioGroupContext = /*#__PURE__*/React.createContext(null);
export var RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/radio/context.js
// module id = 163
// module chunks = 0